import React, { useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";

import Chip from "@material-ui/core/Chip";
import { CountryCell, DeviceCell, DateCell, ShieldCell, ActionCell, SecurityCell, UACell, StatusCell } from "./";

export default function BrowserLIsting({ browsers, reload }) {
  const dt = useRef(null);
  const paginatorLeft = (
    <Button type="button" icon="pi pi-refresh" className="p-button-text" />
  );
  const paginatorRight = (
    <Button type="button" icon="pi pi-cloud" className="p-button-text" />
  );

  const exportCSV = () => {
    dt.current.exportCSV();
  };
  const ExportButton = (
    <div style={{ textAlign: "left" }}>
      <Button
        type="button"
        icon="pi pi-external-link"
        label="Export"
        onClick={exportCSV}
      ></Button>
    </div>
  );

  const ActionCellBody = (rowData) => {
    return <ActionCell rowData={rowData} reload={reload}/>;
  };

  if (!browsers || browsers.length < 1) return null;
  return (
    <React.Fragment>
      <div style={{ width: "100%" }} className="datatable-browserlisting">
        <DataTable
          value={browsers}
          autoLayout
          scrollable
          removableSort
          resizableColumns
          columnResizeMode="expand"
          sortField="last_seen_at"
          sortOrder={-1}
          //columnResizeMode="fit"
          paginator
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
          rows={10}
          rowsPerPageOptions={[10, 20, 50]}
          paginatorLeft={paginatorLeft}
          paginatorRight={paginatorRight}
          className="p-datatable-striped"
          footer={ExportButton}
          ref={dt}
        >
          <Column field="browser_id" header="Browser ID" sortable  style={{ width:"250px" }}/>
          <Column field="context.visitor_id" header="Visitor ID" sortable />
          <Column
            field="last_seen_at"
            header="Last Seen At"
            body={DateCell}
            sortable
            style={{ fontSize:"12px",width:"140px" }}
          />
          <Column field="ip" header="IP" sortable body={SecurityCell} style={{ textAlign: "center", width:"120px" }}/>
          <Column
            field="context.ip_details.isocode"
            header="Country"
            body={CountryCell}
            sortable
            style={{ width:"100px" }}
          />
          <Column field="context.ip_details.city" header="City" sortable />
          <Column field="context.ip_details.region" header="Region" sortable style={{ textAlign: "center",width:"70px" }}/>
          <Column
            field="context.ua_details.device.type"
            header="Device"
            body={DeviceCell}
            sortable
            style={{ textAlign: "center" }}
          />
          <Column
                      field="context.ua"
                      header="UA"
                      body={UACell}
                      sortable
                      style={{ textAlign: "center" }}
                    />
          <Column field="properties.username" header="Username" sortable />
          <Column
            field="context.shield.device_score"
            header="Shield"
            body={ShieldCell}
            sortable
            style={{ textAlign: "center", width:"86px" }}
          />
          <Column field="status" header="Status" body={StatusCell} sortable style={{  textAlign: "center",width:"116px" }}/>
          <Column header="Actions" body={ActionCellBody} style={{  textAlign: "center",width:"130px" }}/>
        </DataTable>
      </div>
    </React.Fragment>
  );
}
